import { useState } from "react";
import { useNavigate } from "react-router-dom";
import hero from "@/assets/hero-angkor.jpg";

const DURATIONS = [
  { label: "All durations", value: "" },
  { label: "Half day", value: "0.5" },
  { label: "1 day", value: "1" },
  { label: "2 days", value: "2" },
  { label: "3 days", value: "3" },
  { label: "4 days", value: "4" },
  { label: "5–7 days", value: "5-7" },
  { label: "8–14 days", value: "8-14" },
  { label: "15+ days", value: "15+" },
];

const Hero = () => {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [duration, setDuration] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (q.trim()) params.set("q", q.trim());
    if (duration) params.set("duration", duration);
    navigate(`/tours${params.toString() ? `?${params.toString()}` : ""}`);
  };

  return (
    <section className="relative min-h-screen w-full overflow-hidden text-background">
      <img
        src={hero}
        alt="Private Angkor Wat sunrise tour with a French-speaking guide in Siem Reap, Cambodia"
        width={1920}
        height={1280}
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover animate-slow-zoom"
      />
      <div className="absolute inset-0 bg-gradient-hero" />

      <div className="relative z-10 container min-h-screen flex flex-col justify-end pb-24 pt-40">
        <div className="max-w-3xl animate-fade-up">
          <p className="text-xs uppercase tracking-[0.4em] text-background/80 mb-8">
            — Siem Reap · Est. 2009
          </p>
          <h1 className="font-display text-5xl sm:text-7xl md:text-8xl leading-[0.95] text-balance">
            Walk where <em className="text-gold not-italic font-light italic">kings</em><br />
            once whispered<br />to gods.
          </h1>
          <p className="mt-8 max-w-xl text-base md:text-lg text-background/85 font-light leading-relaxed">
            Private Angkor Wat sunrise tours, Phnom Kulen, floating villages and Cambodia birdwatching — led by the best French-speaking guide in Siem Reap and your own private driver across Cambodia.
          </p>

          <form
            onSubmit={handleSearch}
            className="mt-10 max-w-2xl bg-background/95 backdrop-blur p-3 grid grid-cols-1 sm:grid-cols-[1fr_auto_auto] gap-2 shadow-soft"
          >
            <input
              type="text"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search tours — Angkor, Kulen, floating village…"
              aria-label="Search tours"
              className="px-4 py-3 text-sm text-foreground bg-transparent placeholder:text-muted-foreground focus:outline-none border-b sm:border-b-0 sm:border-r border-border"
            />
            <select
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              aria-label="Filter by duration"
              className="px-4 py-3 text-xs uppercase tracking-[0.2em] text-foreground bg-transparent focus:outline-none"
            >
              {DURATIONS.map((d) => (
                <option key={d.value} value={d.value}>{d.label}</option>
              ))}
            </select>
            <button
              type="submit"
              className="bg-foreground text-background px-6 py-3 text-xs uppercase tracking-[0.3em] hover:bg-gold hover:text-ink transition-colors"
            >
              Search
            </button>
          </form>

          <div className="mt-8 flex flex-wrap items-center gap-6">
            <a href="#tours" className="bg-background text-foreground px-8 py-4 text-xs uppercase tracking-[0.3em] hover:bg-gold hover:text-ink transition-colors">
              View Expeditions
            </a>
            <a href="#story" className="text-xs uppercase tracking-[0.3em] border-b border-background/50 pb-1 hover:border-gold hover:text-gold transition-colors">
              Read Our Philosophy
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 right-8 z-10 hidden md:flex items-center gap-3 text-[10px] uppercase tracking-[0.4em] text-background/90 [writing-mode:vertical-rl] rotate-180">
        Scroll · Discover
      </div>
    </section>
  );
};
export default Hero;

